/*
 * @Author: 刘小博
 * @Date: 2023-02-07 14:39:32
 * @LastEditTime: 2023-02-21 14:26:55
 * @LastEditors: 刘小博
 * @Description:
 * @FilePath: \p2ps_vip_web\src\router\behavior-manage\performance-appraisal-manage\modules\selfSupportCheckRouter.js
 * 自营绩效考核  同招商绩效考核公用一个页面及路由
 */
const selfSupportCheckRouter = [
  // 效绩考核 1 月度考核 2 周期考核 3 年度考核
  //自营绩效考核
  {
    path: '/behaviorManage/performance-assess/:meta_type/:selfSupport',
    name: 'behaviorManagePerformanceAssessSelfSupport',
    component: () =>
      // import(
      //   /*webpackChunkName:"behaviorManagePerformanceAssess" */
      //   '@/views/behaviorManage/jiuxin/PerformanceAssess.vue'
      // ),  //待删除文件
      import(
        /*webpackChunkName:"behaviorManagePerformanceAssess" */
        '@/views/behavior-manage/performance-appraisal-manage/attract-investmen-check/Page.vue'
      ), //新迁移文件
    meta: {
      SecondaryMenu: '招商绩效考核', //二级菜单
      isMoreMeta: true,
      1: {
        title: '月度考核',
      },
      2: {
        title: '周期考核',
      },
      3: {
        title: '年度考核',
      },
    },
  },
]
export default selfSupportCheckRouter